import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hide)?_c(VBtn,{attrs:{"icon":_vm.icon,"small":_vm.small,"disabled":_vm.disabled},on:{"click":_vm.print}},[_c(VIcon,[_vm._v("print")]),(_vm.drink === true )?_c(VIcon,[_vm._v("local_bar")]):_vm._e(),(_vm.drink === false )?_c(VIcon,[_vm._v("lunch_dining")]):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }